/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const competitionProfileDtoSchema = z.object({
  name: z.optional(z.string()),
  status: z.optional(z.enum(["Active", "Acquired"]).default("Active")),
  type: z.optional(z.enum(["Direct", "Indirect"]).default("Direct")),
  typeLabel: z.optional(z.string()),
  website: z.optional(z.string()),
  about: z.optional(z.string()),
  differentiation: z.optional(z.string()),
  update: z.string().nullish(),
});
